import * as React from "react";
import { useRouter } from "next/router";

import {
  LOAD_FROM_STORAGE,
  SET_PRODUCTS,
  SET_TIMESLOT,
  SET_PERSONNAL_INFORMATIONS,
  SET_ADDRESS,
  STEP_DATE_URL,
  SET_DELIVERY_ITEMS,
} from "./constants";
import { getItem, setItem } from "lib/sessionStorage";

export const COLLECT_STORAGE_KEY = "murfy_rebranding_collect_storage";

const INITIAL_STATE = {
  step: STEP_DATE_URL,
  postalCode: null,
  products: [],
  productName: null,
  timeslot: null,
  firstname: null,
  lastname: null,
  email: null,
  phone: null,
  address: null,
  addressDetails: null,
  hasOptedIn: false,
  deliveryItems: [],
};

export const CollectFunnelContext = React.createContext(null);

const CollectFunnelReducer = (state, action) => {
  switch (action.type) {
    case LOAD_FROM_STORAGE:
      return { ...state, ...action.data };
    case SET_ADDRESS:
      return { ...state, address: action.data.address, postalCode: action.data.postalCode, timeslot: null };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.data.products,
      };

    case SET_TIMESLOT:
      return { ...state, timeslot: action.data.timeslot };
    case SET_PERSONNAL_INFORMATIONS:
      return { ...state, ...action.data };
    case SET_DELIVERY_ITEMS:
      return { ...state, deliveryItems: action.data.deliveryItems };
    default:
      return INITIAL_STATE;
  }
};

const persistor = (action, type) => {
  const newState = CollectFunnelReducer(action, type);
  setItem(COLLECT_STORAGE_KEY, newState);
  return newState;
};

export const CollectFunnelProvider = ({ children }) => {
  const reducer = React.useReducer(persistor, INITIAL_STATE);
  const { push } = useRouter();

  const [state, dispatch] = reducer;

  React.useEffect(() => {
    const dataFromSessionStorage = getItem(COLLECT_STORAGE_KEY);
    const shouldLoadFromSessionStorage = Boolean(dataFromSessionStorage);
    if (shouldLoadFromSessionStorage) {
      dispatch({
        type: LOAD_FROM_STORAGE,
        data: dataFromSessionStorage,
      });
    }
  }, [dispatch]);

  React.useEffect(() => {
    const shouldRedirect = !(
      state.address ||
      state.products ||
      state.timeslot ||
      state.email ||
      state.firstname ||
      state.lastname ||
      state.phone
    );

    if (shouldRedirect) {
      push(STEP_DATE_URL, undefined);
    }
  }, [
    push,
    state.address,
    state.email,
    state.firstname,
    state.lastname,
    state.phone,
    state.products,
    state.timeslot,
    state.deliveryItems,
  ]);

  return <CollectFunnelContext.Provider value={reducer}>{children}</CollectFunnelContext.Provider>;
};
